module.exports = __webpack_public_path__ + "static/media/aboutimage.fa2d540d.png";